import { render, staticRenderFns } from "./OrganizationPermissions.vue?vue&type=template&id=0a8805ea&"
import script from "./OrganizationPermissions.vue?vue&type=script&lang=js&"
export * from "./OrganizationPermissions.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationPermissions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports